import { render, staticRenderFns } from "./BidderDetails.vue?vue&type=template&id=5de82a08&scoped=true&"
import script from "./BidderDetails.vue?vue&type=script&lang=js&"
export * from "./BidderDetails.vue?vue&type=script&lang=js&"
import style0 from "./BidderDetails.vue?vue&type=style&index=0&id=5de82a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de82a08",
  null
  
)

export default component.exports